<script>
export default {
	data() {
		return {
			Quate: ["Select Service", "House Cleaning", "Car Wash"],
			Provide: ["Select Service", "House Cleaning", "Car Wash"],
			Rochester: ["Rochester", "Wisbech", "Marlow"],
			Fenland: ["Newyork", "Fenland", "Wycombe"],
			Country : ["United States", "United Kingdom"],
			currentStep: 0, // This keeps track of the current step
			steps: [
				{ title: "Choose Category" },
				{ title: "Service Location" },
				{ title: "Personal Info" },
				{ title: "Confirmation" },
        	],
		}
	},
	methods: {
		goToNextStep() {
				// Check if there is a next step
				if (this.currentStep < this.steps.length) {
				this.currentStep += 1;
			}
		},
		goToPreviousStep() {
				// Check if there is a previous step
				if (this.currentStep > 0) {
				this.currentStep -= 1;
			}
		},
    },
}
</script>

<template>

    <!-- Provider Modal -->
	<div class="modal fade" id="provider" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-between">
					<h5>Become a Provider</h5>
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="wizard-fieldset">
					<div class="modal-body pb-0">
						<ul class="d-flex align-items-center flex-wrap mb-1 border-bottom" id="providerwizard">
							<li :class="['d-flex align-items-center me-4 mb-3', { active: currentStep === 0 || currentStep === 1, 'activated' : currentStep > 1 }]" >
								<span class="avatar avatar-md rounded me-2 border-bottom">1</span>
								<h6 class="fs-16 fw-medium">Choose Category</h6>
							</li>
							<li :class="['d-flex align-items-center me-4 mb-3', { active: currentStep === 2 , 'activated' : currentStep > 2 }]">
								<span class="avatar avatar-md rounded me-2">2</span>
								<h6 class="fs-16 fw-medium">Service Location</h6>
							</li>
							<li :class="['d-flex align-items-center me-4 mb-3', { active: currentStep === 3 , 'activated' : currentStep > 3 }]">
								<span class="avatar avatar-md rounded me-2">3</span>
								<h6 class="fs-16 fw-medium">Personal Info</h6>
							</li>
							<li :class="['d-flex align-items-center me-4 mb-3', { active: currentStep === 4 , 'activated' : currentStep > 4 }]">
								<span class="avatar avatar-md rounded me-2">4</span>
								<h6 class="fs-16 fw-medium">Confirmation</h6>
							</li>
						</ul>
					</div>
					<fieldset class="first-field" id="first-field"  v-show="currentStep === 0">
						<div class="modal-body pb-1">
							<div class="bg-light-300 p-3 br-10 text-center mb-4">
								<h4>List your service & Get the leads around you</h4>
								<p>List your service & Get the leads around you</p>
							</div>
							<div class="mb-3">
								<label class="form-label">What type of Service do your Provide?</label>
								<vue-select
									:options="Quate"
									id="quateselect"
									placeholder="Select Service"
								/>
							</div>
							<div class="mb-2">
								<label class="form-label">Popular Service Categories</label>
								<div class="category-badge">
									<span class="badge d-inline-flex align-items-center mb-2 me-2"><img
											src="@/assets/img/icons/service-icon-01.svg" alt="icon"
											class="me-2">Construction</span>
									<span class="badge d-inline-flex align-items-center mb-2 me-2"><img
											src="@/assets/img/icons/service-icon-02.svg" alt="icon"
											class="me-2">Removals</span>
									<span class="badge d-inline-flex align-items-center mb-2 me-2"><img
											src="@/assets/img/icons/service-icon-03.svg" alt="icon" class="me-2">Furniture
										Assembly</span>
									<span class="badge d-inline-flex align-items-center mb-2 me-2"><img
											src="@/assets/img/icons/service-icon-04.svg" alt="icon"
											class="me-2">Electrical</span>
									<span class="badge d-inline-flex align-items-center mb-2"><img
											src="@/assets/img/icons/service-icon-05.svg" alt="icon" class="me-2">Computer
										Service</span>
								</div>
							</div>
						</div>
						<div class="modal-footer text-end">
							<a href="javascript:void(0);" @click="goToNextStep" class="btn btn-linear-primary next_btn">Get Started</a>
						</div>
					</fieldset>
					<fieldset :class="['second-field', currentStep === 1 ? 'd-block' : 'd-none']">
						<div class="modal-body pb-1">
							<div class="bg-light-300 p-3 br-10 text-center mb-4">
								<h4>List your service & Get the leads around you</h4>
								<p>List your service & Get the leads around you</p>
							</div>
							<div class="mb-4">
								<label class="form-label">What type of Service do your Provide?</label>
								<vue-select 
									:options="Provide"
									id="provideselect"
									placeholder="House Cleaning"
								/>
							</div>
							<div class="mb-2">
								<label class="form-label">What type of Sub Services do your Provide?</label>
								<div class="form-check ps-0">
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service1" type="checkbox"
											id="service1" checked>
										<label class="form-check-label ms-2" for="service1">
											Commercial Property
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service2">
										<label class="form-check-label ms-2" for="service2">
											Empty House Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center active mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service3" checked>
										<label class="form-check-label ms-2" for="service3">
											Glass Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service4">
										<label class="form-check-label ms-2" for="service4">
											Carpet washing
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center active mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service5" checked>
										<label class="form-check-label ms-2" for="service5">
											Sofa Washing
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service6">
										<label class="form-check-label ms-2" for="service6">
											Office Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service7">
										<label class="form-check-label ms-2" for="service7">
											Exterior Glass Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service8">
										<label class="form-check-label ms-2" for="service8">
											Shop Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service9">
										<label class="form-check-label ms-2" for="service9">
											Ironing Service
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="service10">
										<label class="form-check-label ms-2" for="service10">
											Bed Washing
										</label>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer d-flex align-items-center justify-content-between">
							<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light prev_btn"><i
									class="ti ti-arrow-left me-2"></i>Back</a>
							<a href="javascript:void(0);" @click="goToNextStep" class="btn btn-linear-primary next_btn">Add Location<i
									class="ti ti-arrow-right ms-2"></i></a>
						</div>
					</fieldset>
					<fieldset :class="currentStep === 2 ? 'd-block' : 'd-none'">
						<div class="modal-body pb-1">
							<div class="bg-light-300 p-3 br-10 text-center mb-4">
								<h4>Where would you like to see leads from?</h4>
								<p>Tell us the area you cover so we can show you leads for your location</p>
							</div>
							<div class="mb-3">
								<label class="form-label">City</label>
								<vue-select 
									:options="Rochester"
									id="rochester"
									placeholder="Rochester"
								/>
							</div>
							<div class="mb-3">
								<label class="form-label">State</label>
								<vue-select 
									:options="Fenland"
									id="fenland"
									placeholder="Newyork"
								/>
							</div>
							<div class="mb-3">
								<label class="form-label">Country</label>
								<vue-select 
									:options="Country"
									id="States"
									placeholder="United States"
								/>
							</div>
						</div>
						<div class="modal-footer d-flex align-items-center justify-content-between">
							<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light prev_btn"><i
									class="ti ti-arrow-left me-2"></i>Back</a>
							<a href="javascript:void(0);" @click="goToNextStep" class="btn btn-linear-primary next_btn">Add Location<i
									class="ti ti-arrow-right ms-2"></i></a>
						</div>
					</fieldset>
					<fieldset :class="currentStep === 3 ? 'd-block' : 'd-none'">
						<div class="modal-body pb-1">
							<div class="bg-light-300 p-3 br-10 text-center mb-4">
								<h4>Some details about you</h4>
								<p>You’re just a few steps away from viewing our House Cleaning leads</p>
							</div>
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-3">
										<label class="form-label">Your Name</label>
										<input type="text" class="form-control">
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-3">
										<label class="form-label">Company Name</label>
										<input type="text" class="form-control">
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-3">
										<label class="form-label">Email</label>
										<input type="email" class="form-control">
									</div>
								</div>
								<div class="col-lg-6">
									<div class="mb-3">
										<label class="form-label">Phone Number</label>
										<input type="text" class="form-control">
									</div>
								</div>
								<div class="col-lg-12">
									<div class="form-check ps-0">
										<label class="form-label d-block">Select Gender</label>
										<div class="form-radio d-inline-flex align-items-center active mb-3 me-3">
											<input class="form-check-input ms-0 mt-0" name="gender" type="radio"
												id="male" checked>
											<label class="form-check-label ms-2" for="male">
												Male
											</label>
										</div>
										<div class="form-radio d-inline-flex align-items-center mb-3">
											<input class="form-check-input ms-0 mt-0" name="gender" type="radio"
												id="female">
											<label class="form-check-label ms-2" for="female">
												Female
											</label>
										</div>
									</div>
									<div class="form-check ps-0">
										<label class="form-label d-block">Does your company have a website?</label>
										<div class="form-radio d-inline-flex align-items-center active mb-3 me-3">
											<input class="form-check-input ms-0 mt-0" name="website" type="radio"
												id="yes" checked>
											<label class="form-check-label ms-2" for="yes">
												Yes
											</label>
										</div>
										<div class="form-radio d-inline-flex align-items-center mb-3">
											<input class="form-check-input ms-0 mt-0" name="website" type="radio"
												id="no">
											<label class="form-check-label ms-2" for="no">
												No
											</label>
										</div>
									</div>
									<div class="form-check ps-0">
										<label class="form-label d-block">Does your company have a website?</label>
										<div class="form-radio d-inline-flex align-items-center active mb-3 me-3">
											<input class="form-check-input ms-0 mt-0" name="emp" type="radio" id="self"
												checked>
											<label class="form-check-label ms-2" for="self">
												Self-employed
											</label>
										</div>
										<div class="form-radio d-inline-flex align-items-center mb-3 me-3">
											<input class="form-check-input ms-0 mt-0" name="emp" type="radio" id="two">
											<label class="form-check-label ms-2" for="two">
												2–10
											</label>
										</div>
										<div class="form-radio d-inline-flex align-items-center mb-3 me-3">
											<input class="form-check-input ms-0 mt-0" name="emp" type="radio"
												id="three">
											<label class="form-check-label ms-2" for="three">
												11–50
											</label>
										</div>
										<div class="form-radio d-inline-flex align-items-center mb-3 me-3">
											<input class="form-check-input ms-0 mt-0" name="emp" type="radio" id="four">
											<label class="form-check-label ms-2" for="four">
												51–200
											</label>
										</div>
										<div class="form-radio d-inline-flex align-items-center mb-3">
											<input class="form-check-input ms-0 mt-0" name="emp" type="radio" id="more">
											<label class="form-check-label ms-2" for="more">
												200+
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer d-flex align-items-center justify-content-between">
							<a href="javascript:void(0);" @click="goToPreviousStep" class="btn btn-light prev_btn"><i
									class="ti ti-arrow-left me-2"></i>Back</a>
							<a href="javascript:void(0);" @click="goToNextStep" class="btn btn-linear-primary next_btn">Submit<i
									class="ti ti-arrow-right ms-2"></i></a>
						</div>
					</fieldset>
					<fieldset :class="currentStep === 4 ? 'd-block' : 'd-none'">
						<div class="modal-body pb-1">
							<div class="bg-light-300 p-3 br-10 text-center mb-4">
								<h4>Maximise your leads</h4>
								<p>Add other services you can provide</p>
							</div>
							<div class="mb-3">
								<label class="form-label d-block">What type of Sub Services do your Provide?</label>
								<span class="badge bg-info fs-13 fw-medium">House Cleaning</span>
							</div>
							<div class="mb-2">
								<label class="form-label">What type of Sub Services do your Provide?</label>
								<div class="form-check ps-0">
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service1" type="checkbox"
											id="services1">
										<label class="form-check-label ms-2" for="services1">
											Commercial Property
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services2">
										<label class="form-check-label ms-2" for="services2">
											Empty House Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center active mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services3" checked>
										<label class="form-check-label ms-2" for="services3">
											Glass Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services4">
										<label class="form-check-label ms-2" for="services4">
											Carpet washing
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center active mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services5" checked>
										<label class="form-check-label ms-2" for="services5">
											Sofa Washing
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services6">
										<label class="form-check-label ms-2" for="services6">
											Office Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services7">
										<label class="form-check-label ms-2" for="services7">
											Exterior Glass Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services8">
										<label class="form-check-label ms-2" for="services8">
											Shop Cleaning
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services9">
										<label class="form-check-label ms-2" for="services9">
											Ironing Service
										</label>
									</div>
									<div class="form-checkbox d-inline-flex align-items-center mb-2 me-3">
										<input class="form-check-input ms-0 mt-0" name="service" type="checkbox"
											id="services10">
										<label class="form-check-label ms-2" for="services10">
											Bed Washing
										</label>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer d-flex align-items-center justify-content-end">
							<a href="javascript:void(0);" data-bs-dismiss="modal" data-bs-toggle="modal"
								data-bs-target="#success_modal" class="btn btn-linear-primary">Confirm & Submit</a>
						</div>
					</fieldset>
				</div>
			</div>
		</div>
	</div>
	<!-- /Provider Modal -->

    <!-- Success Modal -->
	<div class="modal fade" id="success_modal" tabindex="-1" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body text-center">
					<div class="mb-4">
						<span class="success-icon mx-auto mb-4">
							<i class="ti ti-check"></i>
						</span>
						<h4 class="mb-1">Registration Successful</h4>
						<p>You will get a Verification link Via email for the Verify the Account.</p>
					</div>
					<a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-linear-primary">Close</a>
				</div>
			</div>
		</div>
	</div>
	<!-- /Success Modal -->

	<!-- Login Modal -->
	<div class="modal fade" id="login-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<form action="/">
						<div class="text-center mb-3">
							<h3 class="mb-2">Welcome</h3>
							<p>Enter your credentials to access your account</p>
						</div>
						<div class="mb-3">
							<label class="form-label">User Name</label>
							<input type="text" class="form-control">
						</div>
						<div class="mb-3">
							<div class="d-flex align-items-center justify-content-between flex-wrap">
								<label class="form-label">Password</label>
								<a href="javascript:void(0);"
									class="text-primary fw-medium text-decoration-underline mb-1 fs-14"
									data-bs-toggle="modal" data-bs-target="#forgot-modal">Forgot Password?</a>
							</div>
							<input type="password" class="form-control">
						</div>
						<div class="mb-3">
							<div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" value="" id="remembers_me">
									<label class="form-check-label" for="remembers_me">
										Remember Me
									</label>
								</div>
								<div class="form-check">
									<input class="form-check-input" type="checkbox" value="" id="otp_signin">
									<label class="form-check-label" for="otp_signin">
										Sign in with OTP
									</label>
								</div>
							</div>
						</div>
						<div class="mb-3">
							<button type="submit" class="btn btn-lg btn-linear-primary w-100">Sign In</button>
						</div>
						<div class="login-or mb-3">
							<span class="span-or">Or sign in with </span>
						</div>
						<div class="d-flex align-items-center mb-3">
							<a href="javascript:void(0);"
								class="btn btn-light flex-fill d-flex align-items-center justify-content-center me-3"><img
									src="@/assets/img/icons/google-icon.svg" class="me-2" alt="Img">Google</a>
							<a href="javascript:void(0);"
								class="btn btn-light flex-fill d-flex align-items-center justify-content-center"><img
									src="@/assets/img/icons/fb-icon.svg" class="me-2" alt="Img">Facebook</a>
						</div>
						<div class="d-flex justify-content-center">
							<p>Don’t have a account? <a href="javascript:void(0);" class="text-primary"
									data-bs-toggle="modal" data-bs-target="#register-modal"> Join us Today</a></p>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Login Modal -->

	<!-- Register Modal -->
	<div class="modal fade" id="register-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<form action="#">
						<div class="text-center mb-3">
							<h3 class="mb-2">Registration</h3>
							<p>Enter your credentials to access your account</p>
						</div>
						<div class="mb-3">
							<label class="form-label">First Name</label>
							<input type="text" class="form-control">
						</div>
						<div class="mb-3">
							<label class="form-label">Email</label>
							<input type="email" class="form-control">
						</div>
						<div class="mb-3">
							<label class="form-label">Phone Number</label>
							<input class="form-control" id="phone" name="phone" type="text">
						</div>
						<div class="mb-3">
							<div class="d-flex align-items-center justify-content-between flex-wrap">
								<label class="form-label">Password</label>
								<p class="text-gray-6 fw-medium  mb-1">Must be 8 Characters at Least</p>
							</div>
							<input type="password" class="form-control">
						</div>
						<div class="mb-3">
							<div class="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" value="" id="remember_me">
									<label class="form-check-label" for="remember_me">
										I agree to <a href="javascript:void(0);"
											class="text-primary text-decoration-underline">Terms of use</a> & <a
											href="javascript:void(0);"
											class="text-primary text-decoration-underline">Privacy policy</a>
									</label>
								</div>
							</div>
						</div>
						<div class="mb-3">
							<button type="button" data-bs-toggle="modal" data-bs-target="#login-modal"
								class="btn btn-lg btn-linear-primary w-100">Sign Up</button>
						</div>
						<div class="login-or mb-3">
							<span class="span-or">Or sign up with </span>
						</div>
						<div class="d-flex align-items-center mb-3">
							<a href="javascript:void(0);"
								class="btn btn-light flex-fill d-flex align-items-center justify-content-center me-3"><img
									src="@/assets/img/icons/google-icon.svg" class="me-2" alt="Img">Google</a>
							<a href="javascript:void(0);"
								class="btn btn-light flex-fill d-flex align-items-center justify-content-center"><img
									src="@/assets/img/icons/fb-icon.svg" class="me-2" alt="Img">Facebook</a>
						</div>
						<div class=" d-flex justify-content-center">
							<p>Already have a account? <a href="javascript:void(0);" class="text-primary"
									data-bs-target="#login-modal" data-bs-toggle="modal">Sign In</a></p>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Register Modal -->

	<!-- Forgot Modal -->
	<div class="modal fade" id="forgot-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<form action="#">
						<div class="text-center mb-3">
							<h3 class="mb-2">Forgot Password?</h3>
							<p>Enter your email, we will send you a otp to reset your password.</p>
						</div>
						<div class="mb-3">
							<label class="form-label">Email</label>
							<input type="email" class="form-control">
						</div>
						<div class="mb-3">
							<button type="button" class="btn btn-lg btn-linear-primary w-100" data-bs-toggle="modal"
								data-bs-target="#otp-email-modal">Submit</button>
						</div>
						<div class=" d-flex justify-content-center">
							<p>Remember Password? <a href="javascript:void(0);" class="text-primary"
									data-bs-toggle="modal" data-bs-target="#login-modal">Sign In</a></p>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Forgot Modal -->

	<!-- Email otp Modal -->
	<div class="modal fade" id="otp-email-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<form action="#" class="digit-group">
						<div class="text-center mb-3">
							<h3 class="mb-2">Email OTP Verification</h3>
							<p class="fs-14">OTP sent to your Email Address ending ******doe@example.com</p>
						</div>
						<div class="text-center otp-input">
							<div class="d-flex align-items-center mb-3">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold me-3"
									id="digit-1" name="digit-1" data-next="digit-2" maxlength="1">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold me-3"
									id="digit-2" name="digit-2" data-next="digit-3" data-previous="digit-1"
									maxlength="1">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold me-3"
									id="digit-3" name="digit-3" data-next="digit-4" data-previous="digit-2"
									maxlength="1">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold"
									id="digit-4" name="digit-4" data-next="digit-5" data-previous="digit-3"
									maxlength="1">
							</div>
							<div>
								<div class="badge bg-danger-transparent mb-3">
									<p class="d-flex align-items-center "><i class="ti ti-clock me-1"></i>09:59</p>
								</div>
								<div class="mb-3 d-flex justify-content-center">
									<p>Didn't get the OTP? <a href="javascript:void(0);" class="text-primary">Resend
											OTP</a></p>
								</div>
								<div>
									<button type="button" class="btn btn-lg btn-linear-primary w-100"
										data-bs-toggle="modal" data-bs-target="#otp-phone-modal">Verify &
										Proceed</button>
								</div>
							</div>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Email otp Modal -->

	<!-- Phone otp Modal -->
	<div class="modal fade" id="otp-phone-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<form action="#" class="digit-group">
						<div class="text-center mb-3">
							<h3 class="mb-2">Phone OTP Verification</h3>
							<p>OTP sent to your mobile number ending ******9575</p>
						</div>
						<div class="text-center otp-input">
							<div class="d-flex align-items-center mb-3">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold me-3"
									id="digit-5" name="digit-5" data-next="digit-6" maxlength="1">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold me-3"
									id="digit-6" name="digit-6" data-next="digit-7" data-previous="digit-5"
									maxlength="1">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold me-3"
									id="digit-7" name="digit-7" data-next="digit-8" data-previous="digit-6"
									maxlength="1">
								<input type="text" class=" rounded w-100 py-sm-3 py-2 text-center fs-26 fw-bold"
									id="digit-8" name="digit-8" data-next="digit-9" data-previous="digit-7"
									maxlength="1">
							</div>
							<div>
								<div class="badge bg-danger-transparent mb-3">
									<p class="d-flex align-items-center "><i class="ti ti-clock me-1"></i>09:59</p>
								</div>
								<div class="mb-3 d-flex justify-content-center">
									<p>Didn't get the OTP? <a href="javascript:void(0);" class="text-primary">Resend
											OTP</a></p>
								</div>
								<div>
									<button type="button" class="btn btn-lg btn-linear-primary w-100"
										data-bs-toggle="modal" data-bs-target="#reset-password">Verify &
										Proceed</button>
								</div>
							</div>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Phone otp Modal -->

	<!-- Reset password Modal -->
	<div class="modal fade" id="reset-password" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<div class="text-center mb-3">
						<h3 class="mb-2">Reset Password</h3>
						<p class="fs-14">Your new password must be different from previous used passwords.</p>
					</div>
					<form action="#">
						<div class="input-block mb-3">
							<div class="mb-3">
								<label class="form-label">New Password</label>
								<div class="pass-group" id="passwordInput">
									<input type="password" class="form-control pass-input">
								</div>
							</div>
							<div class="password-strength d-flex" id="passwordStrength">
								<span id="poor"></span>
								<span id="weak"></span>
								<span id="strong"></span>
								<span id="heavy"></span>
							</div>
							<div id="passwordInfo" class="mb-2"></div>
							<p class="fs-12">Use 8 or more characters with a mix of letters, numbers & symbols.</p>
						</div>
						<div class="mb-3">
							<div class="d-flex align-items-center justify-content-between flex-wrap">
								<label class="form-label">Confirm Password</label>
							</div>
							<input type="password" class="form-control">
						</div>
						<div>
							<button type="button" class="btn btn-lg btn-linear-primary w-100" data-bs-toggle="modal"
								data-bs-target="#success_modal">Save Change</button>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Reset password Modal -->

	<!-- success message Modal -->
	<div class="modal fade" id="success-modal" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<div class="text-center">
						<span class="success-check mb-3 mx-auto"><i class="ti ti-check"></i></span>
						<h4 class="mb-2">Success</h4>
						<p>Your new password has been successfully saved</p>
						<div>
							<button type="submit" class="btn btn-lg btn-linear-primary w-100">Back to Sign In</button>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
	<!-- /success message Modal -->

	<!-- Free trail Modal -->
	<div class="modal fade" id="free-trail" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
					<a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"><i
							class="ti ti-circle-x-filled fs-20"></i></a>
				</div>
				<div class="modal-body p-4">
					<form action="/">
						<div class="text-center mb-3">
							<h3 class="mb-2">Start your free trial</h3>
						</div>
						<div class="mb-3">
							<label class="form-label">Company Name</label>
							<input type="text" class="form-control">
						</div>
						<div class="mb-3">
							<label class="form-label">Domain</label>
							<input type="text" class="form-control">
						</div>
						<div class="mb-3">
							<div class="row">
								<div class="col-md-6">
									<div>
										<label class="form-label">First Name</label>
										<input type="text" class="form-control">
									</div>
								</div>
								<div class="col-md-6">
									<div>
										<label class="form-label">Last Name</label>
										<input type="text" class="form-control">
									</div>
								</div>
							</div>
						</div>
						<div class="mb-3">
							<label class="form-label">Work Email</label>
							<input type="text" class="form-control">
						</div>
						<div class="mb-3">
							<label class="form-label">Password</label>
							<input type="text" class="form-control">
						</div>
						<div class="mb-3">
							<button type="submit" class="btn btn-lg btn-linear-primary w-100">Register</button>
						</div>
					</form>
				</div>

			</div>
		</div>
	</div>
	<!-- /Free trail Modal -->

</template>